import React from 'react';
import { FlameIcon, BrainIcon, BatteryChargingIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-[#0D0D0D] text-white py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-134">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-5" data-id="element-135"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-136">
        <div className="bg-gradient-to-br from-[#1A1A1A] to-[#0D0D0D] border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-137">
          <h2 className="font-montserrat font-black text-3xl md:text-4xl lg:text-5xl text-center mb-10 leading-tight" data-id="element-138">
            LO QUE PASARÁ EN TUS{' '}
            <span className="text-[#F5C518]" data-id="element-139">PRIMEROS 7 DÍAS</span>
          </h2>

          <p className="font-inter text-xl md:text-2xl text-gray-300 text-center mb-12 leading-relaxed" data-id="element-140">
            Tu cuerpo dejará de usar azúcar como combustible y empezará a{' '}
            <strong className="text-white" data-id="element-141">quemar tu propia grasa.</strong>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-142">
            <div className="flex flex-col items-center text-center p-6 bg-white/5 rounded-2xl" data-id="element-143">
              <FlameIcon className="w-12 h-12 text-[#F5C518] mb-4" data-id="element-144" />
              <h3 className="font-montserrat font-bold text-xl mb-2" data-id="element-145">
                Menos Inflamación
              </h3>
              <p className="font-inter text-gray-400" data-id="element-146">
                Notarás menos inflamación abdominal casi de inmediato.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-6 bg-white/5 rounded-2xl" data-id="element-147">
              <BrainIcon className="w-12 h-12 text-[#F5C518] mb-4" data-id="element-148" />
              <h3 className="font-montserrat font-bold text-xl mb-2" data-id="element-149">
                Claridad Mental
              </h3>
              <p className="font-inter text-gray-400" data-id="element-150">
                Adiós a la niebla mental, más enfoque durante todo el día.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-6 bg-white/5 rounded-2xl" data-id="element-151">
              <BatteryChargingIcon className="w-12 h-12 text-[#F5C518] mb-4" data-id="element-152" />
              <h3 className="font-montserrat font-bold text-xl mb-2" data-id="element-153">
                Energía Constante
              </h3>
              <p className="font-inter text-gray-400" data-id="element-154">
                El fin de esos "bajonazos" de energía después de almuerzo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}